import { Injectable, inject, Signal } from '@angular/core';
import { isDefined } from '@lyceo/shared/util';
import { filter, map, Observable } from 'rxjs';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { UserProfile } from '@lyceo/shared/auth/util-models';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class AccessCheckService {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public readonly userProfile: Signal<UserProfile | undefined> =
    this.authFacade.userProfile;

  public hasRequiredRole(requiredRoles: string[]): Observable<boolean> {
    return toObservable(this.userProfile).pipe(
      filter(isDefined),
      map((userProfile) => {
        if (!userProfile.roles) {
          return false;
        }
        return userProfile.roles.some((role) => requiredRoles.includes(role));
      }),
    );
  }
}
